'use client'

import { usePathname } from 'next/navigation'
import { useEffect } from 'react'

const AppcuesPageTracker = () => {
  const pathname = usePathname()

  useEffect(() => {
    if (typeof window === 'undefined' || !window.AppcuesReady) return

    window.AppcuesReady(() => {
      window.Appcues?.page()
    })
  }, [pathname])

  return null
}

export default AppcuesPageTracker
